module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres7de-detail-tab3"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES7DEP3']['10']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.detailTab3Columns,
      "data": _vm.detailTab3,
      "editEvent": _vm.editEvent,
      "maxRowspan": _vm.detailTab3MaxRowspan
    }
  })], 1)]), _vm._v(" "), _c('input', {
    ref: "popup",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres7de-popup-tab3",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "nowLang": _vm.nowLang,
      "detailTab3Selected": _vm.detailTab3Selected,
      "detailTab3Popup": _vm.detailTab3Popup,
      "searchIndex": _vm.searchIndex,
      "codeval": _vm.codeval,
      "indexSelected": _vm.indexSelected,
      "postHres7deTab3PopupSave": _vm.postHres7deTab3PopupSave,
      "searchDetail": _vm.searchDetail
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0adf3a55!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres7de/detailTab3.vue
// module id = 3537
// module chunks = 1